import { render, staticRenderFns } from "./workRemarkAdd.vue?vue&type=template&id=ce42a9f8&scoped=true&"
import script from "./workRemarkAdd.vue?vue&type=script&lang=js&"
export * from "./workRemarkAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce42a9f8",
  null
  
)

export default component.exports